import React from 'react'; 
import SeatBookingTabs from '../components/SeatBookingTabs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { faArrowLeft, faPlus, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

export default function Reservations() {
  const navigate = useNavigate();
  
  const handleNavigation = (path) => {
    navigate(path);
  };
  
  return (
    <div className="bg-gray-100 h-screen flex flex-col relative">
      <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
        <button className="text-gray-600 flex items-center" onClick={() => handleNavigation(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} size="lg" />
        </button>

        <div className="flex items-center gap-2">
          <h1 className="text-gray-600 font-semibold text-lg text-center">
            My Seat Bookings
          </h1>
          <button className="ml-4 text-gray-600 flex items-center" onClick={() => window.location.reload()}>
            <FontAwesomeIcon icon={faRotateRight} size="lg" />
          </button>
        </div>

        <button className="text-gray-600 flex items-center justify-end" onClick={() => handleNavigation('/calendar')}>
          <FontAwesomeIcon icon={faCalendar} size="lg" />
        </button>
      </nav>
      
      <hr />

      <div className="overflow-y-auto flex-grow">
        <SeatBookingTabs />
      </div>

      <div className="bg-white flex justify-center items-center sticky bottom-0 z-10">
        <button 
          className="w-5/6 mt-2 mb-2 px-2 py-3 border font-semibold border-[#BE1F18] text-[#BE1F18] hover:bg-[#BE1F18] hover:text-white text-base rounded"
          onClick={() => handleNavigation('/allRoutes')}
        >
          <FontAwesomeIcon icon={faPlus} size="sm" /> Book Seats
        </button>
      </div>
      
    </div>

  );
}
